import appService from '../js/appservice/index'
import funcs from '../js/helpers/misc'
import { getErrorMessage } from '../js/helpers/storehelper'

const state = {
  defaultResellerGroupId: null,
  resellerGroups: [],
  customerGroups: [],
  userGroupError: '',
  currentGroup: {},
  userCompany: {},
  customerTypes: [],
  defaultCustomerTypeId: 3,
  defaultCustomerTypeName: 'Kund',
  customerTags: [],
  mailTemplates: [],
  availableTestMethods: [],
  availableScales: [],
  customTestMethods: {},
  currentCustomTestMethod: {},
  creditTransactions: []
}

const getters = {
  defaultResellerGroupId: state => state.defaultResellerGroupId,
  resellerGroups: state => state.resellerGroups,
  customerGroups: state => state.customerGroups,
  userGroupError: state => state.userGroupError,
  currentGroup: state => state.currentGroup,
  userCompany: state => state.userCompany,
  customerTypes: state => state.customerTypes,
  defaultCustomerTypeId: state => state.defaultCustomerTypeId,
  defaultCustomerTypeName: state => state.defaultCustomerTypeName,
  customerTags: state => state.customerTags,
  availableTestMethods: state => state.availableTestMethods,
  availableScales: state => state.availableScales,
  customTestMethods: state => state.customTestMethods,
  currentCustomTestMethod: state => state.currentCustomTestMethod,
  creditTransactions: state => state.creditTransactions
}

const actions = {
  getMyResellerGroups(context) {
    let userId = funcs.tryCallService()
    return new Promise(resolve => {
      appService.users
        .getMyResellerGroups(userId)
        .then(data => {
          context.commit('getMyResellerGroups', data)
          resolve()
        })
        .catch(error => {
          state.userGroupError = error.data
        })
    })
  },
  getMyCustomerGroups(context, resellerGroupId) {
    let userId = funcs.tryCallService()
    return new Promise(resolve => {
      if (userId !== null) {
        appService.users
          .getMyCustomerGroups(userId, resellerGroupId)
          .then(data => {
            context.commit('getMyCustomerGroups', data)
            resolve()
          })
          .catch(error => {
            state.userGroupError = error.data
          })
      }
    })
  },
  getMyCompany(context) {
    let userId = funcs.tryCallService()
    return new Promise(resolve => {
      if (userId !== null) {
        appService.users
          .getMyCompany(userId)
          .then(data => {
            window.sessionStorage.setItem('myCompany', JSON.stringify(data))
            context.commit('getMyCompany', data)
            resolve()
          })
          .catch(error => {
            state.userGroupError = error.data
          })
      }
    })
  },
  selectGroup(context, group) {
    context.commit('selectGroup', group)
  },
  saveGroupDetails(context, indata) {
    return new Promise((resolve, reject) => {
      if (!indata.groupId) {
        appService.users
          .addGroup(indata.userId, indata.fData)
          .then(data => {
            context.commit('saveGroupDetails', data)
            resolve()
          })
          .catch(error => {
            reject(getErrorMessage(error))
          })
      } else {
        appService.users
          .updateGroup(indata.userId, indata.fData, indata.groupId)
          .then(data => {
            context.commit('saveGroupDetails', data)
            resolve()
          })
          .catch(error => {
            reject(getErrorMessage(error))
          })
      }
    })
  },
  deleteGroup(context, group) {
    let userId = funcs.tryCallService()
    return new Promise((resolve, reject) => {
      appService.users
        .deleteGroup(userId, group.id)
        .then(() => {
          context.commit('deleteGroup', group)
          resolve({ ok: true })
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  getAvailableTestMethods(context, groupId) {
    let userId = funcs.tryCallService()
    return new Promise(resolve => {
      if (userId !== null) {
        appService.users
          .getAvailableTestMethods(userId, groupId)
          .then(data => {
            context.commit('getAvailableTestMethods', data)
            resolve(data)
          })
          .catch(() => {})
      }
    })
  },
  updateAvailableTestMethods(context, indata) {
    let userId = funcs.tryCallService()
    return new Promise((resolve, reject) => {
      if (userId !== null) {
        appService.users
          .updateAvailableTestMethods(
            userId,
            indata.groupId,
            indata.testMethods
          )
          .then(data => {
            context.commit('updateAvailableTestMethods', data)
            resolve(data)
          })
          .catch(error => {
            reject(getErrorMessage(error))
          })
      }
    })
  },
  getAvailableScales(context, inData) {
    let userId = funcs.tryCallService()
    return new Promise((resolve, reject) => {
      appService.users
        .getAvailableScales(
          userId,
          inData.questionFormat,
          inData.languageId,
          inData.defaultLanguageId
        )
        .then(data => {
          context.commit('getAvailableScales', data)
          resolve(data)
        })
        .catch(error => {
          state.userGroupError = error.data
          reject(getErrorMessage(error))
        })
    })
  },
  getCustomTestMethods(context) {
    let userId = funcs.tryCallService()
    return new Promise((resolve, reject) => {
      appService.users
        .getCustomTestMethods(userId)
        .then(data => {
          context.commit('getCustomTestMethods', data)
          resolve(data)
        })
        .catch(error => {
          state.userGroupError = error.data
          reject(getErrorMessage(error))
        })
    })
  },
  selectCustomTestMethod(context, testMethod) {
    context.commit('selectCustomTestMethod', testMethod)
  },
  getCustomTestMethod(context, inData) {
    let userId = funcs.tryCallService()
    return new Promise((resolve, reject) => {
      appService.users
        .getCustomTestMethod(userId, inData.testMethod, inData.languageId)
        .then(data => {
          context.commit('getCustomTestMethod', data)
          resolve(data)
        })
        .catch(error => {
          state.userGroupError = error.data
          reject(getErrorMessage(error))
        })
    })
  },
  addCustomTestMethod(context, inData) {
    let userId = funcs.tryCallService()
    return new Promise((resolve, reject) => {
      appService.users
        .addCustomTestMethod(userId, inData.testMethod, inData.languageId)
        .then(data => {
          context.commit('addCustomTestMethod', data)
          resolve(data)
        })
        .catch(error => {
          state.userGroupError = error.data
          reject(getErrorMessage(error))
        })
    })
  },
  updateCustomTestMethod(context, inData) {
    let userId = funcs.tryCallService()
    return new Promise((resolve, reject) => {
      appService.users
        .updateCustomTestMethod(userId, inData.testMethod, inData.languageId)
        .then(data => {
          context.commit('updateCustomTestMethod', data)
          resolve(data)
        })
        .catch(error => {
          state.userGroupError = error.data
          reject(getErrorMessage(error))
        })
    })
  },
  deleteCustomTestMethod(context, inData) {
    let userId = funcs.tryCallService()
    return new Promise((resolve, reject) => {
      appService.users
        .deleteCustomTestMethod(userId, inData.testMethod)
        .then(data => {
          context.commit('deleteCustomTestMethod', data)
          resolve(data)
        })
        .catch(error => {
          state.userGroupError = error.data
          reject(getErrorMessage(error))
        })
    })
  },
  getAvailableNormGroups(context, group) {
    let userId = funcs.tryCallService()
    return new Promise(resolve => {
      appService.users
        .getAvailableNormGroups(userId, group.id)
        .then(data => {
          context.commit('getAvailableNormGroups', data)
          resolve({ ok: true })
        })
        .catch(error => {
          state.userGroupError = error.data
          resolve({ ok: false, message: error.data })
        })
    })
  },
  getUser(context) {
    let userId = funcs.tryCallService()

    return new Promise((resolve, reject) => {
      appService.users
        .getUser(userId)
        .then(data => {
          resolve(data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  getUserById(context, userId) {
    return new Promise((resolve, reject) => {
      appService.users
        .getUser(userId)
        .then(data => {
          resolve(data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  addUser(context, userInfo) {
    return new Promise(resolve => {
      appService.users
        .addUser(userInfo)
        .then(data => {
          context.commit('addUser', { userInfo: userInfo, newUser: data })
          resolve({ ok: true })
        })
        .catch(error => {
          state.userGroupError = error.data
          resolve({ ok: false, message: error.data })
        })
    })
  },
  updateUserPermissions(context, payload) {
    return new Promise(resolve => {
      appService.users
        .updateUserPermissions(payload.userId, payload.permissions)
        .then(data => {
          resolve({ ok: true })
        })
        .catch(error => {
          state.userGroupError = error.data
          resolve({ ok: false, message: error.data })
        })
    })
  },
  updateUser(context, userInfo) {
    return new Promise(resolve => {
      appService.users
        .updateUser(userInfo.currentUser.id, userInfo.newUser)
        .then(data => {
          context.commit('updateUser', {
            currentUser: userInfo.currentUser,
            newUser: data
          })
          resolve({ ok: true })
        })
        .catch(error => {
          state.userGroupError = error.data
          resolve({ ok: false, message: error.data })
        })
    })
  },
  deleteUser(context, data) {
    return new Promise((resolve, reject) => {
      appService.users
        .deleteUser(data.user.id)
        .then(() => {
          context.commit('deleteUser', data)
          resolve()
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  addCustomerTypeTranslations(context, data) {
    context.commit('addCustomerTypeTranslations', data)
  },
  getCustomerTags(context) {
    let userId = funcs.tryCallService()
    return new Promise((resolve, reject) => {
      appService.users
        .getCustomerTags(userId)
        .then(data => {
          context.commit('getCustomerTags', data)
          resolve(data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  addCustomerTag(context, tag) {
    let userId = funcs.tryCallService()
    return new Promise((resolve, reject) => {
      appService.users
        .addCustomerTag(userId, tag)
        .then(data => {
          context.commit('addCustomerTag', data)
          resolve(data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  updateCustomerTag(context, tag) {
    let userId = funcs.tryCallService()
    return new Promise((resolve, reject) => {
      appService.users
        .updateCustomerTag(userId, tag)
        .then(data => {
          context.commit('updateCustomerTag', data)
          resolve(data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  deleteCustomerTag(context, tag) {
    let userId = funcs.tryCallService()
    return new Promise((resolve, reject) => {
      appService.users
        .deleteCustomerTag(userId, tag)
        .then(data => {
          context.commit('deleteCustomerTag', tag)
          resolve(data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  getMailTemplates(context) {
    let userId = funcs.tryCallService()
    return new Promise((resolve, reject) => {
      appService.users
        .getMailTemplates(userId)
        .then(data => {
          context.commit('getMailTemplates', data)
          resolve(data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  addMailTemplate(context, mailTemplate) {
    let userId = funcs.tryCallService()
    return new Promise((resolve, reject) => {
      appService.users
        .addMailTemplate(userId, mailTemplate)
        .then(data => {
          context.commit('addMailTemplate', data)
          resolve(data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  updateMailTemplate(context, mailTemplate) {
    let userId = funcs.tryCallService()
    return new Promise((resolve, reject) => {
      appService.users
        .updateMailTemplate(userId, mailTemplate)
        .then(data => {
          context.commit('updateMailTemplate', data)
          resolve(data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  deleteMailTemplate(context, mailTemplate) {
    let userId = funcs.tryCallService()
    return new Promise((resolve, reject) => {
      appService.users
        .deleteMailTemplate(userId, mailTemplate)
        .then(data => {
          context.commit('deleteMailTemplate', mailTemplate)
          resolve(data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  getCreditTransactions(context, searchCriteria) {
    let userId = funcs.tryCallService()
    return new Promise((resolve, reject) => {
      appService.users
        .getCreditTransactions(
          userId,
          searchCriteria.groupId,
          searchCriteria.dateFrom,
          searchCriteria.dateTo
        )
        .then(data => {
          context.commit('getCreditTransactions', data)
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

const mutations = {
  getMyResellerGroups(state, data) {
    if (data.length > 0) {
      state.defaultResellerGroupId = data[0].id
    }
    state.resellerGroups = data
  },
  getMyCustomerGroups(state, data) {
    data.forEach(element => {
      element.userGroupType = funcs.getCustomerTypeName(
        element.userGroupTypeId,
        state.customerTypes
      )
    })
    state.customerGroups = data
  },
  getMyCompany(state, data) {
    state.userCompany = data
  },
  selectGroup(state, data) {
    state.currentGroup = data
  },
  deleteGroup(state, data) {
    var index = state.customerGroups.indexOf(data)

    if (index !== -1) {
      state.customerGroups.splice(index, 1)
    }

    index = funcs.getIndexInCollection('id', data.id, state.resellerGroups)

    if (index !== -1) {
      state.resellerGroups.splice(index, 1)
    }
  },
  saveGroupDetails(state, data) {
    if (!state.currentGroup.id) {
      state.customerGroups.push(data)
    }

    state.currentGroup = data
    state.currentGroup.userGroupType = funcs.getCustomerTypeName(
      data.userGroupTypeId,
      state.customerTypes
    )
  },
  addUser(state, data) {
    var group = funcs.findGroup(data.userInfo.groupId, state.customerGroups)
    group.members.push(data.newUser)
  },
  updateUser(state, data) {
    data.currentUser.isActive = data.newUser.isActive
    data.currentUser.email = data.newUser.email
    data.currentUser.latestLoginDate = data.newUser.latestLoginDate
    data.currentUser.numLogins = data.newUser.numLogins
  },
  deleteUser(state, data) {
    var index = funcs.getIndexInCollection(
      'id',
      data.user.id,
      data.group.members
    )

    if (index !== -1) {
      data.group.members.splice(index, 1)
    }
  },
  addCustomerTypeTranslations(state, data) {
    state.customerTypes = data
  },
  getCustomerTags(state, data) {
    state.customerTags = data
  },
  addCustomerTag(state, data) {
    state.customerTags.push(data)
  },
  updateCustomerTag(state, data) {
    var index = funcs.getIndexInCollection('id', data.id, state.customerTags)

    if (index !== -1) {
      state.customerTags[index] = data
    }
  },
  deleteCustomerTag(state, data) {
    var index = funcs.getIndexInCollection('id', data.id, state.customerTags)

    if (index !== -1) {
      state.customerTags.splice(index, 1)
    }
  },
  getMailTemplates(state, data) {
    state.mailTemplates = data
  },
  addMailTemplate(state, data) {
    state.mailTemplates.push(data)
  },
  updateMailTemplate(state, data) {
    var index = funcs.getIndexInCollection('id', data.id, state.mailTemplates)

    if (index !== -1) {
      state.mailTemplates[index] = data
    }
  },
  deleteMailTemplate(state, data) {
    var index = funcs.getIndexInCollection('id', data.id, state.mailTemplates)

    if (index !== -1) {
      state.mailTemplates.splice(index, 1)
    }
  },
  getAvailableTestMethods(state, data) {
    state.availableTestMethods = data
  },
  updateAvailableTestMethods(state, data) {
    state.availableTestMethods.forEach(tm => {
      let arr = data.filter(d => d.id === data.id)

      if (arr.length > 0) {
        tm.selected = arr[0].selected
      }
    })
  },
  getAvailableScales(state, data) {
    state.availableScales = data
  },
  getCustomTestMethods(state, data) {
    state.customTestMethods = data
  },
  selectCustomTestMethod(state, data) {
    state.currentCustomTestMethod = data
  },
  getCustomTestMethod(state, data) {
    state.currentCustomTestMethod = data
  },
  addCustomTestMethod(state, data) {
    state.currentCustomTestMethod = data
    state.customTestMethods.push(data)
  },
  updateCustomTestMethod(state, data) {
    state.currentCustomTestMethod = data
  },
  deleteCustomTestMethod(state, data) {
    const index = funcs.getIndexInCollection(
      'id',
      data.id,
      state.customTestMethods
    )
    if (index !== -1) {
      state.customTestMethods.splice(index, 1)
    }
  },
  getCreditTransactions(state, data) {
    state.creditTransactions = data
  }
}

if (typeof window !== 'undefined') {
  document.addEventListener('DOMContentLoaded', function(event) {
    let companyString = window.sessionStorage.getItem('myCompany')

    if (companyString && companyString.length > 0) {
      state.userCompany = JSON.parse(companyString)
    }
  })
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
